import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/atoms/button';

interface FormPageHeaderProps {
  backLink: string;
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export function FormPageHeader({ backLink, title, description, children }: FormPageHeaderProps) {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button variant="ghost" size="icon" asChild>
        <Link to={backLink}>
          <ArrowLeft className="size-5" />
        </Link>
      </Button>
      <div className="flex-1">
        <h1 className="text-2xl font-bold">{title}</h1>
        {description && <p className="text-muted-foreground">{description}</p>}
      </div>
      {children}
    </div>
  );
}
